import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'container',
  'headerRow',
  'title',
  'description',
  'featuredWrapper',
  'firstRow',
  'blogGrid',
  'ctaContainer',
  'cta',
  // Style 2 specific parts
  'twoColRow',
  'twoColLarge',
  'twoColSmall',
  'threeColRow'
]);

export const blogGridStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {},
  },

  variants: {
    /**
     * Style 1 - Featured hero blog with 3-column grid below
     */
    'Style 1': () => ({
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: {base: 10, md: 12},
        width: '100%',
        maxWidth: '1440px',
        mx: 'auto',
        px: {base: 5, md: 20},
        py: {base: 14, md: 20},
        backgroundColor: 'brandColors.secondaryBG',
      },

      title: {
        color: 'brandColors.greyscale90',
        fontFamily: 'heading',
        fontSize: {base: '28px', md: '40px'},
        fontWeight: '500',
        lineHeight: '120%',
        letterSpacing: {base: '-0.28px', md: '-0.4px'},
        margin: 0,
      },

      featuredWrapper: {
        width: '100%',
      },

      blogGrid: {
        columns: {base: 1, md: 3},
        spacing: {base: 8, md: 10},
        width: '100%',
      },

      ctaContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        pt: {base: 4, md: 8},
      },

      cta: {
        // CTA button styling handled by ActionLinks component
      },
    }),

    /**
     * Style 2 - King Journal (Blog Listing Page)
     * Alternating row pattern:
     * - Row 1: 2 columns (65% left, 35% right)
     * - Row 2: 3 columns equal
     * - Row 3: 2 columns (35% left, 65% right)
     * - Row 4: 3 columns equal
     * - Repeat...
     */
    'Style 2': () => ({
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: {base: 8, md: 10},
        width: '100%',
        maxWidth: '1440px',
        mx: 'auto',
        px: {base: 5, md: 20},
        py: {base: 14, md: 20},
        backgroundColor: 'brandColors.secondaryBG',
      },

      headerRow: {
        flexDirection: {base: 'column', md: 'row'},
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: {base: 4, md: 10},
        width: '100%',
        mb: {base: 2, md: 4},
      },

      title: {
        color: 'brandColors.greyscale90',
        fontFamily: 'heading',
        fontSize: {base: '40px', md: '72px'},
        fontWeight: {base: '500', md: '400'},
        lineHeight: {base: '120%', md: '100%'},
        letterSpacing: {base: '-0.4px', md: '-0.72px'},
        margin: 0,
        flex: {base: 'none', md: '0 0 auto'},
        maxWidth: {base: '100%', md: '40%'},
      },

      description: {
        color: 'brandColors.greyscale90',
        fontFamily: 'body',
        fontSize: {base: '16px', md: '20px'},
        fontWeight: '400',
        lineHeight: {base: '160%', md: '150%'},
        margin: 0,
        flex: {base: 'none', md: '1'},
        maxWidth: {base: '100%', md: '55%'},
        mt: {base: 0, md: 10},
      },

      // 2-column row container
      twoColRow: {
        display: 'flex',
        flexDirection: {base: 'column', md: 'row'},
        gap: {base: 8, md: 10},
        width: '100%',
        alignItems: 'stretch',
      },

      // Large column (65%)
      twoColLarge: {
        flex: {base: '1 1 100%', md: '0 0 calc(65% - 20px)'},
        width: {base: '100%', md: 'auto'},
      },

      // Small column (35%)
      twoColSmall: {
        flex: {base: '1 1 100%', md: '0 0 calc(35% - 20px)'},
        width: {base: '100%', md: 'auto'},
      },

      // 3-column row (equal)
      threeColRow: {
        columns: {base: 1, md: 3},
        spacing: {base: 8, md: 10},
        width: '100%',
      },

      ctaContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        pt: {base: 4, md: 8},
      },

      cta: {
        // CTA button styling handled by ActionLinks component
      },
    }),
  },
});
